import Vue from 'vue';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';
// bugsnag configurations

// enables bugsnag notfication if not in development mode or NODE_ENV != disabled
let notifyStage = [process.env.NODE_ENV];
if (['development', 'disabled'].includes(process.env.NODE_ENV)) {
  notifyStage = [];
}

Bugsnag.start({
  apiKey: "2d1d7743923848b28a66a7ca97f65a5b",
  plugins: [new BugsnagPluginVue()],
  enabledReleaseStages: notifyStage,
  releaseStage: process.env.NODE_ENV,
  appVersion: process.env.APP_VERSION,
});

console.info('env', process.env.NODE_ENV);
console.info('Tactful Chat version:', process.env.APP_VERSION);

if (notifyStage.length > 0) {
  console.info('Error reporting enabled');
  // bugsnag plugin-vue
  const bugsnagVue = Bugsnag.getPlugin('vue');
  bugsnagVue.installVueErrorHandler(Vue);

  // notify unhandled rejection errors like promises 
  window.onunhandledrejection = function (event: any) {
    console.error(event);
    Bugsnag.notify(event.reason);

  };
} else {
  console.info('Error reporting disabled');
}

export default Bugsnag;